import type { IframePoolItem } from '../../../modules/api';
import { formatPrice } from '../../../modules/currency';
import { Image } from '../../../modules/design-system';

type Props = {
  item: IframePoolItem;
  onClick: (item: IframePoolItem) => void;
};

/** A potential hit in the phone's sheet (repackz-handoff §8.2): the bare slab
 *  with its rounded value "~$456" on a dark glass tag at the bottom. */
export function HitTile({ item, onClick }: Props) {
  return (
    <button
      type="button"
      onClick={() => onClick(item)}
      aria-label={item.title}
      className="relative aspect-[106/168] w-full cursor-pointer overflow-hidden rounded-[4px] transition-transform active:scale-[0.98]"
    >
      <Image
        src={item.imageUrl}
        alt=""
        className="absolute inset-0"
        imgClassName="absolute inset-0 h-full w-full object-contain"
        width={106}
        height={168}
      />
      <span className="absolute bottom-1.5 left-1/2 flex h-6 -translate-x-1/2 items-center whitespace-nowrap rounded-full px-2 text-[13px] font-medium text-white backdrop-blur-[12px] [background:var(--glass-tag-fill)]">
        ~{formatPrice(item.itemPrice, 0)}
      </span>
    </button>
  );
}
